import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  private emailInvitedSearchSource = new BehaviorSubject<string>('');
  private pageSizeSource = new BehaviorSubject<number>(50);
  private currentPageSource = new BehaviorSubject<number>(0);

  emailInvitedSearch$ = this.emailInvitedSearchSource.asObservable();
  pageSize$ = this.pageSizeSource.asObservable();
  currentPage$ = this.currentPageSource.asObservable();

  updateEmailInvitedSearch(email: string) {
    this.emailInvitedSearchSource.next(email);
  }

  updatePageSize(pageSize: number) {
    this.pageSizeSource.next(pageSize);
  }

  updateCurrentPage(currentPage: number) {
    this.currentPageSource.next(currentPage);
  }
}
